document.querySelectorAll('.sr-accordion-header').forEach(header => {
  header.addEventListener('click', () => {
    const item = header.parentElement;
    const isOpen = item.classList.contains('sr-active');

    // Close all
    document.querySelectorAll('.sr-accordion-item').forEach(i => i.classList.remove('sr-active'));

    // Toggle current
    if (!isOpen) {
      item.classList.add('sr-active');
    }
  });
});
